<template>
  <div class="history-center d_flex flex_direction_col">
    <!-- 状态 -->
    <!-- <div :class="`pro-state ${stateColor(itemDetail.state)}`">
      {{stateDesc}}
    </div> -->
    <div class="detail_main_info d_flex justify_content_sb flex_direction_col">
      <!-- block-1 -->
      <div class="main_block_1">
        <!-- 时间文本 -->
        <div class="state-time-line c_1A1A1A" v-if="stateTimeDesc(itemDetail.state)">
          <div>
            <span  class="state-time-desc cell_label fz12"
              >{{ stateTimeDesc(itemDetail.state) }}：</span
            >
            <!-- 时间文本 -->
            <span class="state-time c_1A1A1A font_w_bold">{{ stateTime }}</span>
          </div>
        </div>

        <!-- 项目展示价格（成交价，当前价） -->
        <div class="price_w">
          <div class="cell_row d_flex">
            <span class="cell_label fz12 c_1A1A1A" >{{priceDesc(itemDetail.state)}}</span>
            <span class="fz12 c_CF3342">
              <el-tooltip effect="dark" :content="amountTran(itemDetail.project.price)" placement="top">
                <em class="fz24 font_w_bold" style="margin: 0 5px">{{
                  formatMoney(itemDetail.project.price)
                }}</em>
              </el-tooltip>
            </span>
            <span class="fz12 c_CF3342"
              >{{ itemDetail.priceUnitDesc }}
            </span>
            <!-- <span v-if="itemDetail.priceUnit === 'zongjia'" class="fz12 c_CF3342"
              >（总价）
            </span> -->
          </div>
        </div>
      </div>

      <!-- block-2 -->
      <div class="main_block_2 flex_direction_col bc_e6e6e6">
        <div class="block-outer" >
          <div class="block-inner">
            <!-- 备注 -->
            <div class="state-remark" v-if="isShowStateRemark">
              {{ stateRemark }}
            </div>
          </div>
        </div>
      </div>

      <!-- block-3 -->
      <div class="main_block_3 d_flex fz12">
        <span class="cell_i c_808080"
          ><em class="fz16 c_1A1A1A">{{ itemDetail.statis.onlookerCnt || 0}}</em
          >次围观</span
        >

      </div>
    </div>
    <!-- block-4 -->
    <div class="main_block_4 fz12 c_808080">
      <div class="cell_row d_flex flex_wrap">
        <div class="" style="flex: 0.33">
          <span>是否缴纳交易保证金：</span>
          <span>{{ whether[itemDetail.deposit] }}</span>
        </div>
        <div class="" style="flex: 0.33">
          <span>交易保证金：</span>
          <el-tooltip   effect="dark" :content="amountTran(itemDetail.margin)" placement="top">
            <span>￥{{ numTranFloat(itemDetail.margin) }}</span>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auction_checkNotice } from "@/api/portal";
import { mapGetters, mapActions } from "vuex";
import {
  formatDate,
  tranTimeFormat,
  confirmCallBack,
  numTurnText,
  uuid,
  amountTran,
  numTranFloat
} from "@/utils";
import Cookies from "js-cookie";

import { MySocket } from "@/utils/webSocket";
import {TradeModeText} from '@/enums'

export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
    reqInfoTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      rules: {
      },
      allowApply: false, //是否已报名（未知是否审批通过）
      publicForm: {},
    };
  },
  computed: {
    ...mapGetters(["isLogin", "cmsNoticeNode", "userinfo", "priceUnitKey",'stateAllKey','whether']),
    amountTran:function(){
      return function(num){
        return amountTran(num)
      }
    },
    numTranFloat:function(){
      return function(num){
        return numTranFloat(num)
      }
    },
    //格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    // 价格描述
    priceDesc(){
      return function(state){
        let text = ''
        switch(state){
          case 4: text = '成交价：';break;
          default: text = '价格：';break;
        }
        return text
      }
    },
    // 状态
    stateDesc(){
      return this.stateAllKey[this.itemDetail.project.tradeMode][this.itemDetail.state]
    },
    // 状态时间文本
    stateTimeDesc() {
      return function(state){
        let text = "";
        switch (state) {
          case 3: text = '';break;
          case 4: text = '结束时间';break
        }
        return text;
      }
    },
    // 状态时间线
    stateTime(){
      let text = ''
        switch(this.itemDetail.state){
          case 4: text = this.itemDetail.stateEndTime;break;
        }
        return text
    },
    // 状态颜色
    stateColor(){
      return function(state){
        let text = "";
        switch (state) {
          case 3: text = "bc_22D179";break;
          case 4: text = "bc_808080";break;
        }
        return text;
      }
    },
    // 状态备注
    stateRemark() {
      let text = "";
      switch (this.itemDetail.state) {
        case 4:
          text = '项目已交易';break;
        default:
          text = this.itemDetail.stateRemark;
      }
      return text;
    },
    // 是否显示状态备注
    isShowStateRemark() {
      return [3, 4].includes(this.itemDetail.state);
    },
    tradeModeText(){
      return TradeModeText[this.itemDetail.project.tradeMode]
    }
  },
  async created() {
    console.log('dealcenter',this.reqInfoTime)
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      initNoticeNode: "cache/initNoticeNode",
    }),

  },
  destroyed() {

  },
};
</script>

<style lang="scss" scoped>
.history-center {
  overflow: hidden;
  position: relative;
  width: 440px;
  margin: 0 10px;
  border: 1px solid #e6e6e6;
  .pro-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    line-height: 170px;
    transform: translate(50px, -50px) rotateZ(45deg);
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
.detail_main_info {
  .state-time-line{
    margin: 10px 0;
  }
  .price_w {
    margin: 10px 0;
    & > span {
      &:first-child {
        margin: 0 18px 0 0;
      }
    }
  }
  .state_end_desc {
    margin: 0 0 12px 0;
    & > img {
      margin: 0 14px 0 0;
    }
  }

  .main_block_1 {
    position: relative;
    min-height: 100px;
    padding: 10px;
    box-sizing: border-box;
    .cell_label {
      display: inline-block;
      min-width: 60px;
      white-space: nowrap;
      text-align: right;
    }
    .time_i {
      margin: 0 4px 0 0;
    }
    .time_num {
      margin: 0 5px;
    }
    .tradeMode-text{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 12px;
      background-color: #0983cc;
      color: #fff;
      padding: 4px 10px;
    }
  }
  .main_block_2 {
    height: 140px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
    .block-outer{
      display: flex;
      justify-content: center;
      height: 100%;
      .block-inner{
        display: flex;
        align-items: center;
        .state-remark {
          color: #666;
        }
      }
    }
  }
  .main_block_3 {
    .cell_i {
      height: 32px;
      line-height: 32px;
      flex: 1;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      border-top: 1px solid #e6e6e6;
      &:last-child {
        border-left: 1px solid #e6e6e6;
      }
    }
  }
}
.cell_row {
  margin: 10px 0;
  align-items: baseline;
}
.main_block_4 {
  padding: 0 20px;
  .cell_row {
    margin: 10px 0;
  }
}
</style>
